import React from 'react';

// Provider
import { AptcProvider } from '../hooks/useAptcContext';

// Contexts
import { ModalContextType } from '../../../../contexts/modalContext';

// Modals
import { PlanSummaryModals } from './planSummaryModals';
import { IPlan } from '../planSummary.types';

// Constants
import APTCSuccessModal from './APTCSuccessModal';

interface IModalProps extends ModalContextType {
    plan: IPlan;
    maxAptc: number;
    premiumEffDate: string;
}

const APTCSuccessModalContainer = ({
    plan,
    premiumEffDate,
    closeModal,
    openModal,
}: IModalProps) => {
    function onClose(e) {
        e?.preventDefault();
        closeModal(PlanSummaryModals.APTCSuccess);
    }

    return (
        <AptcProvider electedAptc={Number(plan.electedAptc)}>
            <APTCSuccessModal
                maxAptc={plan.maxAptc ? Number(plan.maxAptc) : 0}
                premiumEffDate={premiumEffDate}
                plan={plan}
                onClose={onClose}
                openModal={openModal}
            />
        </AptcProvider>
    );
};

export default APTCSuccessModalContainer;
